/**
 * Adds a trailing slash to any URL
 * @param url a URL string
 * @returns a URL string with a trailing slash
 */
export const addTrailingSlash = (url: string) => {
  let index = url.search(/[?#]/);
  if (index === 0) return url; // URL starts with ? or #
  if (index < 0) index = url.length; // URL does not have a query fragment
  const path = url.slice(0, index).replace(/\/$/, '');
  if (/\.[A-z]{2,4}$/.exec(path)) return url; // URL is possibly a file or domain
  const queryFragment = url.slice(index);
  return `${path}/${queryFragment}`;
};

export default {
  addTrailingSlash,
};
